import { isDevMode, NgModule } from "@angular/core";
import { ServiceWorkerModule as SWModule } from "@angular/service-worker";
import { CommonModule } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { TranslateModule } from "@ngx-translate/core";
import { ServiceWorkerComponent } from "./service-worker.component";
import { ServiceWorkerService } from "./service-worker.service";

@NgModule({
    imports: [
        CommonModule,
        SWModule,
        SWModule.register("ngsw-worker.js", {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: "registerWhenStable:30000"
        }),

        MatSnackBarModule,
        MatButtonModule,
        TranslateModule
    ],
    declarations: [ServiceWorkerComponent],
    providers: [ServiceWorkerService]
})
export class ServiceWorkerModule {}
